import { render } from "./User.vue?vue&type=template&id=2f7f365f&scoped=true&ts=true&lang=pug"
import script from "./User.vue?vue&type=script&lang=ts"
export * from "./User.vue?vue&type=script&lang=ts"

import "./User.vue?vue&type=style&index=0&id=2f7f365f&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f7f365f"]])

export default __exports__